import styles from "./PartSurveyItemUsed.module.scss";
import { useTranslation } from 'react-i18next'
import { useState } from "react";
import pieeeeechart from 'assets/icons/pieeeeechart.png';
import Notification from "utils/Notifications";
import { ChangeDefendant } from "service/TestService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartSurveyItemUse = ({ item, item_selected, item_selected_data, index, setRender }) => {
  const { t } = useTranslation('common')

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            return <p>Invalid content format</p>;
        }
        const editorState = EditorState.createWithContent(contentState);
        return <Editor editorState={editorState} readOnly toolbarHidden />;
    };

    const getSelectedData = (defendantId, key) => {
        const selectedItem = item_selected_data.find(data =>
            Array.isArray(data.userusetsurveypart_employee_tsurveys) &&
            data.userusetsurveypart_employee_tsurveys.some(test => test.defendant === defendantId)
        );
    
        return selectedItem?.userusetsurveypart_employee_tsurveys.find(test => test.defendant === defendantId)?.[key] || false;
    };
    

    return (
        <div className={styles.defendant_card_selection}>
            {item.employee === item_selected.employee && (
                <h3>{
                    {
                        singleSelection: "Одиночный выбор",
                        multipleSelection: "Множественный выбор",
                        numericInput: "Ввод числа",
                        textInput: "Ввод текста",
                        freeTextDefendant: "Ответ в свободной форме",
                        sequenceOrdering: "Установление последовательности",
                        slider: "Слайдер (ползунок)",
                        fileUpload: "Загрузка файла",
                        infoText: "Информационный текст",
                    }[item.type_defendant] || "Тип не определён"
                }</h3>
            )}
            {item.image && <img src={item.image} className={styles.img_file} alt={t('auto.components_partsurveyitemuse.k4')} />}
            <div className={styles.defendant_card_selection_body}>
                <h3><DraftContent draftData={item.body} /></h3>
                {Number(item_selected) !== Number(item.id) && item.type_defendant !== "infoText" && (
                    <div className={styles.defendant_card_selection_body_defendant}>{t('auto.components_partsurveyitemuse.k1')}</div>
                )}
                {Number(item_selected) === Number(item.id) && (
                    <>
                        <h4>{t('auto.components_partsurveyitemuse.k2')}</h4>
                        <div className={styles.defendant_card_selection_body_defendant}>
                            {item.defendant_part_survey.map(defendant => (
                                <div key={defendant.id} style={{ width: '100%' }}>
                                    {item.type_defendant === "freeTextDefendant" ? (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div}>
                                                {getSelectedData(defendant.id, "free_response")}
                                            </div>
                                        </div>
                                    ) : item.type_defendant === "fileUpload" ? (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div}>{t('auto.components_partsurveyitemuse.k3')}</div>
                                        </div>
                                    ) : (
                                        <div className={styles.defendant_card_header}>
                                            {(item.type_defendant === "sequenceOrdering") && (
                                                <>
                                                    <DraftContent draftData={defendant.title} />
                                                    <select className={styles.point_check_num_text}>
                                                        <option value={1}>{1}</option>
                                                    </select>
                                                </>
                                            )}
                                            {(item.type_defendant === "slider") && (
                                                <div className={styles.slider_min_max}>
                                                    <input type="range" min={0} max={100} defaultValue={0} style={{ width: '100%' }} />
                                                    <span className={styles.slider_min_max_res}>{0}</span>
                                                </div>
                                            )}
                                            {(item.type_defendant === "numericInput") && (
                                                 getSelectedData(defendant.id, "type_input_int")
                                            )}
                                            {(item.type_defendant === "textInput") && (
                                                getSelectedData(defendant.id, "type_input_txt")
                                            )}
                                            {(item.type_defendant === "singleSelection") && (
                                                <>
                                                    <input type="radio" id={`defendant-${defendant.id}`} checked={!!getSelectedData(defendant.id, "right_defendant")} readOnly />
                                                    <DraftContent draftData={defendant.title} />
                                                </>
                                            )}
                                            {(item.type_defendant === "multipleSelection") && (
                                                <>
                                                    <input type="checkbox" id={`defendant-${defendant.id}`} checked={!!getSelectedData(defendant.id, "right_defendant")} readOnly />
                                                    <DraftContent draftData={defendant.title} />
                                                </>
                                            )}
                                        </div>
                                    )}
                                    {defendant.file && <img src={defendant.file} className={styles.img_file} alt={t('common.file')} />}
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {item.comment && (
                    <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <DraftContent draftData={item.comment} />
                    </div>
                )}
            </div>
            <hr />
            <Notification notify={notify} setNotify={setNotify} />
        </div>
    );
};

export default PartSurveyItemUse;
